export enum Feature {
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  TENANT_NETWORK_WIDGET = 'TENANT_NETWORK_WIDGET',
  WOMENS_DAY_VOUCHER_MODAL = 'WOMENS_DAY_VOUCHER_MODAL',
  WOHNEN_PLUS_LIGHT = 'WOHNEN_PLUS_LIGHT',
  BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT = 'BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
